import { Suspense, useRef } from 'react';
import { motion } from 'framer-motion';
import { Canvas } from '@react-three/fiber';
import { View } from '@react-three/drei';

import { Ball } from './canvas';
import { SectionWrapper } from '../hoc';
import { technologies, tools } from '../constants';
import { textVariant } from '../utils/motion';
import { styles } from '../styles'


const Tech = () => {
  // Every ball used to mount its own <Canvas>, which meant ~20 WebGL contexts on
  // this page alone. Browsers cap the number of live contexts (Chrome drops the
  // oldest once you pass ~16), so the hero model and a handful of balls would go
  // blank. drei's <View> draws all of them into the single Canvas below.
  const containerRef = useRef(null);

  return (
    <div ref={containerRef} className="relative">
      <motion.div variants={textVariant()}>
        <p className={styles.sectionSubText}>
          My Skills
        </p>
        <h2 className={styles.sectionHeadText}>
          Technologies.
        </h2>
      </motion.div>
      <div className="flex flex-row flex-wrap justify-center gap-10 mt-10">
        {technologies.map((technology) => (
          <View className="w-28 h-28" key={technology.name}>
            <Suspense fallback={null}>
              <Ball imgUrl={technology.icon} />
            </Suspense>
          </View>
        ))}
      </div>

      <motion.div variants={textVariant()} className="mt-10">
        <h2 className={styles.sectionHeadText}>
          Tools and Frameworks.
        </h2>
      </motion.div>
      <div className="flex flex-row flex-wrap justify-center gap-10 mt-10">
        {tools.map((tool) => (
          <View className="w-28 h-28" key={tool.name}>
            <Suspense fallback={null}>
              <Ball imgUrl={tool.icon} />
            </Suspense>
          </View>
        ))}
      </div>

      <Canvas
        eventSource={containerRef}
        shadows
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          pointerEvents: 'none',
        }}
      >
        <View.Port />
      </Canvas>
    </div>
  )
}

export default SectionWrapper(Tech, "");
